module.exports = __webpack_public_path__ + "img/e70da0f.png";